module.exports = __webpack_public_path__ + "img/icon-error.24fbce5d.svg";